window.addEventListener("load", function () {
  const deliveryEstimateElement = document.querySelector(
    ".order-delivery-estimate"
  );

  if (deliveryEstimateElement) {
    console.log("HTML do deliveryEstimateElement foi carregado.");
    const maxDeliveryTime = parseInt(
      deliveryEstimateElement.dataset.maxDeliveryTime,
      10
    );
    const earliestInStockDeliveryTime = parseInt(
      deliveryEstimateElement.dataset.earliestInStockDeliveryTime,
      10
    );
    const isSwitzerland =
      deliveryEstimateElement.dataset.isSwitzerland === "true";
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentDay = currentDate.getDay();
    const maxDeliveryDate = addBusinessDays(
      currentDate,
      maxDeliveryTime,
      currentHour
    );
    const inStockDeliveryDate = addBusinessDays(
      currentDate,
      earliestInStockDeliveryTime,
      currentHour
    );

    const maxDeliveryFormatted = formatDate(maxDeliveryDate);
    const inStockDeliveryFormatted = formatDate(inStockDeliveryDate);

    // Renders the delivery date for products out of stock
    deliveryEstimateElement.querySelector(".order-delivery-date").textContent =
      maxDeliveryFormatted;

    const inStockElement = deliveryEstimateElement.querySelector(
      ".in-stock-delivery-date"
    );

    console.log("inStockElement", inStockElement);
    console.log("inStockElement.dataset", inStockElement.dataset);

    // Renders the delivery date for products in stock
    if (earliestInStockDeliveryTime > 0) {
      // if is in switzerland and delivery time is 1 or 2 days and not friday
      if (
        isSwitzerland &&
        earliestInStockDeliveryTime <= 2 &&
        currentDay !== 5
      ) {
        // Delivery in 1 or 2 days for Switzerland
        const deliveryMessage =
          currentHour >= 16
            ? inStockElement.dataset.localeAfterTomorrow
            : inStockElement.dataset.localeTomorrow;
        inStockElement.textContent = deliveryMessage;
      } else {
        // for others countries or more than 2 days
        inStockElement.textContent = inStockDeliveryFormatted;
      }
    }
  }

  function addBusinessDays(date, days, currentHour) {
    let count = 0;
    let newDate = new Date(date);

    if (currentHour >= 16) {
      days++;
    }

    while (count < days) {
      newDate.setDate(newDate.getDate() + 1);
      if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
        count++;
      }
    }

    return newDate;
  }

  function formatDate(date) {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
});
